import { A11yModule } from '@angular/cdk/a11y';
import { ObserversModule } from '@angular/cdk/observers';
import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { TabBodyDirective } from './tab-body.directive';
import { TabButtonBarDirective } from './tab-button-bar.directive';
import { StringToTabIdPipe } from './tab-id-to-string.pipe';
import { TabItemComponent } from './tab-item/tab-item.component';
import { TabLabelWrapper } from './tab-label-wrapper/tab-label-wrapper.directive';
import { TabHeaderComponent } from './tabs-header/tabs-header.component';
import { TabsComponent } from './tabs.component';

@NgModule({
  declarations: [TabBodyDirective, TabButtonBarDirective, TabsComponent, TabHeaderComponent, TabLabelWrapper, TabItemComponent, StringToTabIdPipe],
  imports: [CommonModule, OverlayModule, TranslateModule.forChild({ extend: true }), ObserversModule, A11yModule],
  exports: [TabButtonBarDirective, TabBodyDirective, TabsComponent, TabItemComponent, StringToTabIdPipe]
})
export class AvanoTabsModule {}
